import { DialogAction } from '../actions/dialog'

export interface DialogState {
  title: string
  message: string
  open: boolean
}

const initialState: DialogState = {
  title: '',
  message: '',
  open: true
}

const dialog = (state: DialogState = initialState, action: DialogAction): DialogState => {
  switch (action.type) {
    case 'SET_DIALOG_MESSAGE':
      return {
        ...state,
        title: action.title,
        message: action.message
      }
    case 'CLEAR_DIALOG':
      return { ...initialState }
    default:
      return state
  }
}

export default dialog
